import { useEffect, useRef, useState } from 'react'
import { ThreeDS } from './paymentCard'
import criarWatchdog3DS from './watchdog3DS'

export interface DadosCartao3DS {
  numero: string
  mes: string
  ano: string
  titular: string
}

export interface IniciarDesafioParams {
  cartao: DadosCartao3DS
}

interface Use3DSCallbacks {
  onSuccess: (threeDS: ThreeDS) => void
  onFailure: (evento: unknown) => void
  onError: (evento: unknown) => void
  /** Nenhum evento chegou em TIMEOUT_3DS_MS depois do `Checkout`. */
  onTimeout: () => void
}

interface Mpi3DSSuccessEvent {
  Cavv: string
  Xid?: string | null
  Eci: string
  Version: string
  ReferenceId?: string | null
}

export default function use3DS(callbacks: Use3DSCallbacks) {
  const cbRef = useRef(callbacks)
  cbRef.current = callbacks

  const registrado = useRef(false)
  const [watchdog] = useState(criarWatchdog3DS)

  // Separado do registro dos listeners: tem de valer mesmo quando o SDK não
  // estava carregado no mount.
  useEffect(() => () => watchdog.limpar(), [watchdog])

  useEffect(() => {
    const mpi = (window as any)?.Safe2Pay?.Mpi
    if (!mpi || registrado.current) return

    mpi.addEventListener('onSuccess', (e: Mpi3DSSuccessEvent) => {
      watchdog.limpar()
      cbRef.current.onSuccess({
        Cavv: e.Cavv,
        Xid: e.Xid ?? null,
        Eci: e.Eci,
        Version: e.Version,
        ReferenceId: e.ReferenceId ?? null,
      })
    })

    mpi.addEventListener('onFailure', (e: unknown) => {
      watchdog.limpar()
      cbRef.current.onFailure(e)
    })

    mpi.addEventListener('onError', (e: unknown) => {
      watchdog.limpar()
      cbRef.current.onError(e)
    })

    registrado.current = true
  }, [watchdog])

  function inicializar(amount: number): boolean {
    const mpi = (window as any)?.Safe2Pay?.Mpi
    if (!mpi) return false

    mpi.Init(
      {
        IsEnabled: true,
        IsSandbox: false,
        IsDebug: false,
        IsChallengeSuppressed: false,
      },
      amount
    )

    return true
  }

  function iniciarDesafio({ cartao }: IniciarDesafioParams): boolean {
    const mpi = (window as any)?.Safe2Pay?.Mpi
    if (!mpi) return false

    watchdog.armar(() => cbRef.current.onTimeout())

    mpi.Checkout({
      currency: 'BRL',
      installments: '01',
      cardnumber: cartao.numero,
      cardexpirationmonth: cartao.mes,
      cardexpirationyear: cartao.ano,
      cardalias: cartao.titular,
    })

    return true
  }

  return { inicializar, iniciarDesafio }
}